import { Tabs as Tabs } from "flowbite-react";
export default Tabs;
